import { Injectable } from '@angular/core';
import { IApiRouteService } from '../../models/route';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { NtApiItemPreform } from '../types/item-preform';
import { ApiNtAssemblyItemDto } from '../dto/assembly-item';

@Injectable({
  providedIn: 'root',
})
export class ApiNtAssemblyItemService extends IApiRouteService {
  constructor(protected readonly http: HttpClient) {
    super();
  }

  protected urlRoute = environment.otherApis.netsuiteV2 + '/api/assembly-item';

  preformCompression(query?: string): Observable<NtApiItemPreform[]> {
    return this.http.get<NtApiItemPreform[]>(
      `${this.urlRoute}/preform/used-on-compression${query ? `?${query}` : ''}`
    );
  }

  hosesMoldsName(hoseId: number): Observable<string[]> {
    return this.http.get<string[]>(`${this.urlRoute}/hoses/${hoseId}/mold`);
  }

  phantomBom(
    id: string | number
  ): Observable<ApiNtAssemblyItemDto['phantomBom']['return']> {
    return this.http.get<any>(`${this.urlRoute}/plastic/bom/${id}`);
  }

  hosesPrivateLabelItems(): Observable<string[]> {
    return this.http.get<string[]>(
      `${this.urlRoute}/hoses/private-label-items`
    );
  }

  getInfo(
    id: string | number
  ): Observable<ApiNtAssemblyItemDto['getInfo']['return']> {
    return this.http.get<any>(`${this.urlRoute}/${id}/get-info`);
  }

  getBom(
    id: string | number
  ): Observable<ApiNtAssemblyItemDto['getBom']['return']> {
    return this.http.get<any>(`${this.urlRoute}/${id}/bom`);
  }

  openSalesOrders(
    id: number
  ): Observable<ApiNtAssemblyItemDto['openSalesOrders']['return']> {
    return this.http.get<ApiNtAssemblyItemDto['openSalesOrders']['return']>(
      `${this.urlRoute}/${id}/open-sales-orders`
    );
  }

  getChildItemsIsUsedOn(partNumber: string | number): Observable<string[]> {
    return this.http.get<string[]>(
      `${this.urlRoute}/is-used-on?item=${partNumber}`
    );
  }

  bomItemInformation(
    partNumber: string | number
  ): Observable<ApiNtAssemblyItemDto['itemInformationOfBom']['return']> {
    return this.http.get<any>(`${this.urlRoute}/${partNumber}/bom/item-info`);
  }
}
